//
//
//
//
//
//
//

import firebase from "firebase";
import { db } from "/src/main.js";

export default {
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "DanceNotes";
    },
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit("setUser", user);
        db.ref(`users/${user.uid}/admin`)
          .once("value")
          .then((snapshot) => this.$store.commit("setIsAdmin", snapshot.val()));
      } else {
        this.$store.commit("setUser", null);
        this.$store.commit("setIsAdmin", null);
      }
    });
  },
  mounted() {
    document.title = "DanceNotes";
  },
};
